var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConstruccion({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1925",
    "data-name": "Grupo 1925",
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.228,
    height: 90.226,
    viewBox: "0 0 90.228 90.226",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_057-brickwall",
    "data-name": "057-brickwall"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_233",
    "data-name": "Trazado 233",
    d: "M1.5,90.725H73.687a1.5,1.5,0,0,0,1.5-1.5V75.688H85.717a1.5,1.5,0,0,0,1.5-1.5V59.146a1.5,1.5,0,0,0-1.5-1.5H75.191V44.108a1.5,1.5,0,0,0-1.5-1.5h-2.76a3.478,3.478,0,0,0-.615-2.816l-6.8-9.058,3.138-2.354a5.2,5.2,0,0,0,2.074-4.455l-.151-2.708a2.2,2.2,0,0,1,.876-1.882l3.137-2.353,1.32,1.76a1.5,1.5,0,0,0,.99.587,1.459,1.459,0,0,0,.213.014,1.5,1.5,0,0,0,.9-.3L88.424,9.73a4.511,4.511,0,0,0,.9-6.315L88.49,2.3a4.516,4.516,0,0,0-6.316-.9L69.768,10.707a1.5,1.5,0,0,0-.3,2.106l1.32,1.76L67.65,16.926a5.2,5.2,0,0,0-2.074,4.455l.15,2.708a2.195,2.195,0,0,1-.876,1.882l-3.137,2.354-6.8-9.058a3.487,3.487,0,0,0-3.061-1.406,3.336,3.336,0,0,0-2.7,1.751L36.8,42.6H1.5a1.5,1.5,0,0,0-1.5,1.5V59.146a1.5,1.5,0,0,0,1.5,1.5H12.03V72.68H1.5a1.5,1.5,0,0,0-1.5,1.5V89.222a1.5,1.5,0,0,0,1.5,1.5ZM83.979,3.805a1.5,1.5,0,0,1,2.105.3l.836,1.115a1.5,1.5,0,0,1-.3,2.1l-11.2,8.406-2.64-3.52ZM27.069,75.688H48.122v12.03H27.069ZM39.1,60.65H60.152V72.68H39.1ZM72.183,87.718H51.129V75.688H72.183ZM84.213,72.68H63.159V60.65H84.213ZM72.183,57.642H51.129V48.885l15.392-3.274h5.661ZM51.809,21.036a.314.314,0,0,1,.274-.176h.03a.5.5,0,0,1,.4.213l6.794,9.058-6.2,4.654a1.5,1.5,0,1,0,1.8,2.407l6.2-4.654,6.8,9.058a.486.486,0,0,1,.083.471.315.315,0,0,1-.246.214L37.909,48.622a.489.489,0,0,1-.478-.2.479.479,0,0,1-.062-.515ZM35.026,50.223a3.443,3.443,0,0,0,3.509,1.341l9.587-2.039v8.117H27.069V45.611h8.117l-.466.867a3.457,3.457,0,0,0,.306,3.744Zm-32.018,1.4H6.015a1.5,1.5,0,1,0,0-3.008H3.008V45.611H24.061V57.642H3.008Zm12.03,9.023H36.091V72.68H15.038ZM3.008,75.688H24.061v12.03H3.008Zm0,0",
    transform: "translate(0 -0.499)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_234",
    "data-name": "Trazado 234",
    d: "M68.757,275.062a1.5,1.5,0,0,0-1.5-1.5H61.238a1.5,1.5,0,0,0,0,3.008h6.015A1.5,1.5,0,0,0,68.757,275.062Zm0,0",
    transform: "translate(-49.208 -225.438)",
    fill: "#86888b"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_277",
    "data-name": "Trazado 277",
    d: "M139.426,289.132l-10.258,19.221,20.3-4.967",
    transform: "translate(-86.8 -263.903)",
    fill: "none",
    stroke: "#86888b",
    strokeLinecap: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruccion);
export default __webpack_public_path__ + "static/media/construccion.151c6702d490c74001bdc0783ec2b246.svg";
export { ForwardRef as ReactComponent };